import { render } from "./colorfull.vue?vue&type=template&id=e49bd848&scoped=true"
import script from "./colorfull.vue?vue&type=script&lang=js"
export * from "./colorfull.vue?vue&type=script&lang=js"

import "./colorfull.vue?vue&type=style&index=0&id=e49bd848&scoped=true&lang=scss"

import exportComponent from "D:\\project\\2024\\htos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e49bd848"]])

export default __exports__